<template>
  <div class="order--main-content">
    <div class="card card--no-shadow card-profile">
      <div class="card-header">
        <div class="row align-items-center justify-content-between mb-2">
          <div class="col">
            <h1 class="mb-2 font-regular">Plans</h1>
          </div>
          <div class="col-auto">
            <button class="button button--outline text-uppercase" disabled>
              Create Plan
            </button>
          </div>
        </div>
      </div>

      <div class="card-content">
        <div class="card-body">
          <CDataTable
            :items="plans"
            :fields="planFields"
            :itemsPerPage="small"
            pagination
          >
            <template #actions="{item}">
              <td class="table--action-mobile">
                <router-link
                  :to="{ name: item.name }"
                  class="button"
                  @click="openUpdateFeeModal(item)"
                >
                  View Plan
                </router-link>
              </td>
            </template>
          </CDataTable>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ApiService from "@/services/api.service";
import CDataTable from "@/components/CDataTable.vue";
import CPagination from "@/components/CPagination.vue";
import ErrorService from "@/services/error.service";
import Swal from "sweetalert2";
import { ChevronLeftIcon } from "vue-feather-icons";

const plans = [
  { name: "AutoSave Plan" },
  { name: "Target Plan" },
  { name: "Property Plan" }
];

const planFields = ["name", "actions"];

export default {
  name: "Plans",
  data() {
    return {
      plans,
      planFields
    };
  },
  components: {
    CDataTable
  }
};
</script>

<style scoped></style>
